import styled from "styled-components";

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: var(--section-snow-background-color, var(--snow));
  padding: 32px 24px;
  border-radius: 4px;
`;
